const WORDS = [
  "Moqueca Rainha do Mar",
  "Batida Rainha do Mar",
  "Camarão 7 Barbas",
  "Folha de Mexerica",
  "Barca do Rei",
  "Heineken Estupidamente Gelada",
  "Suco 7 Fontes",
];

const Track = () => (
  <div className="flex shrink-0 items-center">
    {WORDS.map((word) => (
      <span key={word} className="flex items-center">
        <span className="whitespace-nowrap px-8 font-playfair italic text-xl sm:text-2xl lg:text-3xl text-[#F4EBD9]">
          {word}
        </span>
        <span className="text-[#E9C46A] text-sm">✦</span>
      </span>
    ))}
  </div>
);

export default function EditorialMarquee() {
  return (
    <section
      data-testid="editorial-marquee"
      aria-label="Destaques do cardápio"
      className="marquee-paused overflow-hidden border-y border-[#E9C46A]/15 bg-[#0D5C63] py-6 sm:py-8"
    >
      <div className="animate-marquee flex w-max">
        <Track />
        <Track />
      </div>
    </section>
  );
}
